import List from './List';
import Create from './Create';
import Edit from './Edit/index';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'assignments',
  inputShow: gql`
    query assignments($input: AssignmentQueryInput) {
      assignments(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Assignments',
    group: 'root',
    order: 6,
  },
};
